import PropTypes from 'prop-types';
import UserDetail from "components/ui/UserDetail/UserDetail";
import Button from "components/ui/Button/Button";
import { ReactComponent as IconArrow } from "assets/images/icons/arrow-right.svg";
import { ReactComponent as IconAttachment } from "assets/images/icons/attachment.svg";
import "pages/MessageBox/MessageBoxTeaser.scss";
import { useHistory } from "react-router-dom";

function MessageBoxTeaser({ profile, created, message, image, isRead }) {
  const history = useHistory();
  return (
    <div className={ 'message-box-teaser' }>
      <div className={ 'message-box-teaser__header' }>
        <div className={ 'message-box-teaser__user' }>
          <UserDetail username={ profile?.title?.value }
                      image={ profile?.field_profile_photo?.value }
                      subtext={ created.long }
                      url={ `/berichtenbox?user_id=` + profile.uid }/>
        </div>

        {
          image?.value &&
          <div className={ `message-box-teaser__attachment` }>
            <IconAttachment/>
          </div>
        }
        {
          !isRead &&
          <div className={ `message-box-teaser__new` }>
            <div className={ `message-box-teaser__new-label` }>
              Nieuw
            </div>
          </div>
        }

        <div className={ 'message-box-teaser__button' }>
          <Button onClick={ () => history.push(`/berichtenbox?user_id=` + profile.uid) }
                  variant={ 'secondary' }
                  className={ 'button--square' }>
            <IconArrow/>
          </Button>
        </div>
      </div>

      <div className={ 'message-box-teaser__content' }>
        { message.teaser }
      </div>
    </div>
  );
}

MessageBoxTeaser.propTypes = {
  profile: PropTypes.object.isRequired,
  created: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  image: PropTypes.object,
  isRead: PropTypes.bool.isRequired
}

export default MessageBoxTeaser;
